import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-lg transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#c9a07a] hover:bg-[#d4a574] text-[#1e2a38] shadow-lg hover:shadow-xl focus:ring-[#c9a07a]',
    secondary: 'bg-[#1e2a38] hover:bg-[#2a3441] text-white shadow-lg hover:shadow-xl focus:ring-[#1e2a38]',
    outline: 'bg-transparent border-2 border-[#1e2a38] text-[#1e2a38] hover:bg-[#1e2a38] hover:text-white'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-132">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-133" />}
    </motion.button>;
}